import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function getMediaQuery(): MediaQueryList | undefined {
	return typeof window.matchMedia === 'function' ? window.matchMedia(QUERY) : undefined;
}

function subscribe(onChange: () => void): () => void {
	const mediaQuery = getMediaQuery();
	if (!mediaQuery) return () => undefined;
	// Safari/iOS < 14 (still in the es2015 bundle's targets) only implement the deprecated listener API.
	if (typeof mediaQuery.addEventListener !== 'function') {
		mediaQuery.addListener(onChange);
		return () => mediaQuery.removeListener(onChange);
	}
	mediaQuery.addEventListener('change', onChange);
	return () => mediaQuery.removeEventListener('change', onChange);
}

/**
 * Whether the supporter asked for reduced motion (`prefers-reduced-motion: reduce`); false on the server.
 */
export function usePrefersReducedMotion(): boolean {
	return useSyncExternalStore(
		subscribe,
		() => getMediaQuery()?.matches ?? false,
		() => false,
	);
}
